import service from "./service"

const startPreCheckSession = async (data) => {
    return service(data)
}

export default startPreCheckSession
